export enum ListingPhotoKind {
  Large = 'large',
  SearchPagePreview = 'search-page-preview',
}
